module.exports = __webpack_public_path__ + "media/images/admin/icons/package-36491f59b1b671191adda523d805e801.svg";